<lin-layout-section title="{{ vehicle.regNo }} ({{ vehicle.defaultLabel }}) - {{ vehicle.model }}">
  @if (groupTitle) {
  <lin-layout-section-meta label="{{ 'CLIENT.VEHICLES.GROUPS' | translate }}" [value]="groupTitle"> </lin-layout-section-meta>
  } @if (vehicle.depot) {
  <lin-layout-section-meta label="{{ 'CLIENT.VEHICLES.DEPOT' | translate }}" [value]="depotTitle"> </lin-layout-section-meta>
  }
  <ng-content></ng-content>
</lin-layout-section>
